import angular from 'angular';
import angularUiBootstrap from 'angular-ui-bootstrap';
import {ProjectBrowserService} from "./project-browser.service";

export default angular.module('slViz.projectBrowserModule', [
    angularUiBootstrap
])
    .service('ProjectBrowserService', ProjectBrowserService)
    .name;



// WEBPACK FOOTER //
// ./src/js/components/project-browser/index.js